import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import resizeListener from '../../../components/resizeListenerComponent';
import BarChart from './BarChart';

class StatisticsPageViewGraph extends PureComponent {
    static propTypes = {
        profileStatistics: PropTypes.shape({
            uniqueEmployerVisitsList: PropTypes.arrayOf(
                PropTypes.shape({
                    dateFormatted: PropTypes.string,
                    count: PropTypes.number,
                })
            ),
        }),
        width: PropTypes.number,
    };

    renderGraph() {
        if (this.props.width) {
            return (
                <BarChart
                    data={this.props.profileStatistics.uniqueEmployerVisitsList}
                    width={this.props.width}
                    x="dateFormatted"
                    y="count"
                />
            );
        }
    }

    render() {
        return (
            <div className="mhl" ref="container">
                {this.renderGraph()}
            </div>
        );
    }
}

export default resizeListener(StatisticsPageViewGraph);
